import React from 'react';
import { SVGOverlay } from 'react-map-gl';
import {
  brandColors,
  brandLightColors,
  colors,
  fleetStyleColors,
  fleetStyleLightColors,
} from '../../../theme/theme';
import { useSelector } from 'react-redux';
import { selectSelectedArea } from '../../../redux/store/appData/areas';
import { selectAdminBrands } from '../../../redux/store/userData/user/selectors';

const getCoordinates = (area) => {
  return area.geoJSONData.features[0].geometry.coordinates.map(
    (coordinate: string) => {
      const coordinateArr = coordinate.split(' ');
      return [Number(coordinateArr[0]), Number(coordinateArr[1])];
    }
  );
};

const AreaPolygon: React.FC = () => {
  const selectedArea = useSelector(selectSelectedArea);
  const brands = useSelector(selectAdminBrands);

  const redraw = ({ project }: any) => {
    const fleetStyle = selectedArea?.fleetStyle;
    const brandId = brands[0]?.id;

    const color =
      fleetStyleColors[fleetStyle] ||
      brandColors[brandId] ||
      colors.area_selected;

    const fillColor =
      fleetStyleLightColors[fleetStyle] || brandLightColors[brandId];

    const coordinates = getCoordinates(selectedArea);
    const points = coordinates.map((coordinate: any[]) => {
      return project([coordinate[0], coordinate[1]]).join(',');
    });

    return (
      <polygon
        key={`area-${selectedArea.id}`}
        id={`area-polygon-${selectedArea.id}`}
        points={points.join(' ')}
        style={{
          fill: fillColor || color,
          fillOpacity: fillColor ? 1 : 0.2,
          stroke: color,
          strokeOpacity: 1,
          strokeWidth: 2,
          cursor: 'pointer',
        }}
      />
    );
  };

  return <SVGOverlay redraw={redraw} />;
};

export default AreaPolygon;
